import { useEffect, useState } from 'react';
import { useToastStore } from '../store/toastStore';
import type { Toast } from '../store/toastStore';

const FADE_DURATION = 400;

const BACKGROUND_COLORS: Record<string, string> = {
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6',
};

function ToastItem({ toast }: { toast: Toast }) {
    const remove = useToastStore((s) => s.remove);
    const [fading, setFading] = useState(false);

    useEffect(() => {
        const fadeTimer = setTimeout(() => setFading(true), toast.duration - FADE_DURATION);
        const removeTimer = setTimeout(() => remove(toast.id), toast.duration);
        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(removeTimer);
        };
    }, [toast.id, toast.duration, remove]);

    return (
        <div
            className={`toast toast-${toast.type}`}
            onClick={() => remove(toast.id)}
            style={{
                background: BACKGROUND_COLORS[toast.type],
                color: 'white',
                padding: '12px 20px',
                borderRadius: '6px',
                marginBottom: '10px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                pointerEvents: 'auto',
                cursor: 'pointer',
                maxWidth: '350px',
                wordWrap: 'break-word',
                opacity: fading ? 0 : 1,
                transition: `opacity ${FADE_DURATION}ms ease`,
            }}
        >
            {toast.message}
        </div>
    );
}

export function ToastList() {
    const toasts = useToastStore((s) => s.toasts);

    return (
        <div
            style={{
                position: 'fixed',
                top: '20px',
                right: '20px',
                zIndex: 1000,
                pointerEvents: 'none',
            }}
        >
            {toasts.map((t) => (
                <ToastItem key={t.id} toast={t} />
            ))}
        </div>
    );
}
